<div class="query-result-panel">
  <div class="search-wrapper">
    <span class="nfl-form-label" nz-typography>Search</span>
    <span class="search-box">
      <nz-input-group>
        <input
          nz-input
          nzSize="default"
          placeholder="Enter the search text..."
          [(ngModel)]="searchValue"
          type="text"
          nz-tooltip
          [nzTooltipTitle]="isLimitingSearch ? LIMITING_SEARCH_MESSAGE : null"
          [disabled]="isLoading || isLimitingSearch"
        />
      </nz-input-group>
    </span>
    <span class="search-button-wrapper">
      <button
        nz-button
        nzType="default"
        type="button"
        class="generate-button disabled-btn"
        (click)="search()"
        nz-tooltip
        [nzTooltipTitle]="isLimitingSearch ? LIMITING_SEARCH_MESSAGE : null"
        [disabled]="isLoading || isLimitingSearch"
      >
        Search
      </button>
      <button
        nz-button
        nzType="default"
        type="button"
        class="disabled-btn green-btn"
        [disabled]="!searchValue || isLoading"
        (click)="reset()"
      >
        Reset
      </button>
    </span>
  </div>

  <div class="result-table-wrapper">
    <div class="table-content">
      <nz-table
        #nzTable
        nzSize="small"
        [nzData]="rows"
        nzTableLayout="auto"
        nzShowPagination
        nzShowSizeChanger
        [nzFrontPagination]="false"
        [nzLoading]="isLoading"
        [nzTotal]="totalCount"
        [nzPageIndex]="pageIndex"
        [nzPageSize]="pageSize"
        [nzNoResult]="noResultTemplate"
        [nzHideOnSinglePage]="false"
        [nzScroll]="{ x: 'max-content' }"
        nzBordered
        (nzPageIndexChange)="onPageChange($event)"
        (nzPageSizeChange)="onPageSizeChange($event)"
      >
        <thead>
          <tr>
            <th
              nzCustomFilter
              *ngFor="let header of headers"
              [nzSortOrder]="header.sortOrder"
              [nzSortFn]="header.sortFn"
              [nzSortDirections]="header.sortDirections"
              class="nfl-form-label result-header-cell"
            >
              {{ header.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of nzTable.data">
            <td
              *ngFor="let header of headers"
              class="result-body-cell"
              nz-tooltip
              [nzTooltipTitle]="getValue(data, header.key)"
            >
              {{ getValue(data, header.key) }}
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>

  <ng-template #noResultTemplate>
    <div>
      <span nz-icon class="no-data-icon" nzType="file-sync" nzTheme="outline"></span>
      <p>Table information is being loaded, or there are currently no records available</p>
    </div>
  </ng-template>
</div>
